// The game's creative catalog and the spec reference, shared by Settings and the creative pages.

import type { CatalogReference, CreativeCatalog } from '@growth/client';
import { useApi } from '../session.tsx';

export function useCatalog(gameId: string) {
  return useApi<{ catalog: CreativeCatalog; reference: CatalogReference }>(`catalog:${gameId}`, (a, s) => a.creativeCatalog(gameId, s));
}
